<template>
  <v-item-group>
    <v-row>
      <v-col v-for="word in this.$store.state.words.data" :key="word.id">
        <v-lazy :options="{ threshold: 1 }"
                transition="fade-transition">
          <v-chip close color="orange" label outlined @click:close="deleteWord(word.id)">
            {{word.content}}
          </v-chip>
        </v-lazy>
      </v-col>
    </v-row>
  </v-item-group>
</template>

<script>

export default {
  name: 'Word',
  data: () => ({}),
  mounted () {
    this.$store.watch(
      () => this.$store.state.words.page !== this.$store.state.words.pervs_page,
      (value) => {
        if (value) {
          this.getWords()
        }
      })

    this.getWords()
  },
  methods: {

    getWords () {
      this.$store.state.words.loading = true
      const $url = `${this.$store.state.api.base_url}${this.$store.state.api.all_words}?page=${this.$store.state.words.page}&per_page=${this.$store.state.words.per_page}`
      this.$store.dispatch('ajaxCall', {
        url: $url,
        method: 'GET',
        token: this.$store.state.access_token
      }).then(resp => {
        this.$store.state.words.loading = false
        this.$store.state.words.total_pages = resp.data.last_page
        this.$store.state.words.data = resp.data.data
        this.$store.state.words.pervs_page = this.$store.state.words.page
        //  console.log('getWords', this.$store.state.words)
      }).catch(err => {
        this.$store.state.words.loading = false
        console.log('getWords', err)
      })
    },
    deleteWord ($id) {
      alert(`Word ${$id} is deleted!`)
    }
  }
}
</script>
